import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrendingDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 7,
	viewBox: "0 0 12 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.85 1.67023e-07L11.6667 0.816667L7.35 5.1625L5.01667 2.82917L1.98333 5.83333L3.5 5.83333L3.5 7L-3.17891e-07 7L-1.19117e-08 3.5L1.16667 3.5L1.16667 5.01667L5.01667 1.16667L7.35 3.5L10.85 1.67023e-07Z",
		fill: "#E60023"
	})
});
export default SvgTrendingDown;
